;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"AX1l5DWEI0nGsnSTbj25r"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import { sentryEnv } from "@/libs/sentry-config";

// Single format for both client and server: use only NEXT_PUBLIC_* envs
const { enabled: isEnabled, dsn, environment, debug, client } = sentryEnv;

if (isEnabled && dsn) {
  Sentry.init({
    dsn,
    environment,
    debug,
    release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || 'dev-local',
    tracesSampleRate: client.tracesSampleRate,
    replaysSessionSampleRate: client.replaysSessionSampleRate,
    replaysOnErrorSampleRate: client.replaysOnErrorSampleRate,
    tunnel: "/api/e",
    // Disable automatic session tracking if causing issues
    autoSessionTracking: false,
    // Capture all errors in debug mode
    beforeSend(event, hint) {
      // Tag all client-side events explicitly for easy filtering
      event.tags = {
        ...event.tags,
        side: 'frontend',
        runtime: 'browser',
      };

      if (debug) {
        console.log('[Sentry] Sending event:', event.event_id, event.exception);
      }
      return event;
    },
  });
}


